import { render, staticRenderFns } from "./DashboardPorIndicador.vue?vue&type=template&id=1758c2ec"
import script from "./DashboardPorIndicador.vue?vue&type=script&lang=js"
export * from "./DashboardPorIndicador.vue?vue&type=script&lang=js"
import style0 from "./DashboardPorIndicador.vue?vue&type=style&index=0&id=1758c2ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports